import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';

import { getErrorMessage } from '~libs/axiosWrapper';
import { getMonthDateRange } from '~libs/dayjs';

import { ErrorResponse, Spinner } from '~components';
import Icon, { faCheckCircle } from '~components/icon';

import { useGenerateMutation } from '~support-at-home/actions/statements';

import { DateRange } from '../common';

interface ComponentProps {
  value: { client_id: number[]; month: string; include_empty?: boolean };
}

const Review: React.FC<ComponentProps> = ({ value }) => {
  const { client_id = [], month, include_empty } = value;
  const { startDate, endDate } = getMonthDateRange(month);

  const [generateStatements, { data, error, isLoading }] = useGenerateMutation();

  useEffect(() => {
    generateStatements({
      client_ids: client_id,
      start_date: startDate,
      end_date: endDate,
      include_empty,
    });
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner loading={isLoading} />
        <p className="mt-3 text-muted">Generating statements...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <DateRange start_date={startDate} end_date={endDate} title="Statement Period" />
        <ErrorResponse message={getErrorMessage(error)} />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div>
      <DateRange start_date={startDate} end_date={endDate} title="Statement Period" />

      <Alert color="success" className="w-100 mb-3">
        <Icon icon={faCheckCircle} className="me-2" />
        <b>Statements Generated</b>
        <div className="mt-2">
          <p className="mb-1">
            <strong>{data.statements_generated}</strong> statement{data.statements_generated !== 1 ? 's' : ''} created
          </p>
          <p className="mb-0">
            <strong>{data.items_updated}</strong> claim item{data.items_updated !== 1 ? 's' : ''} linked
          </p>
        </div>
      </Alert>
    </div>
  );
};

export default Review;
